import script from "./BaseFileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseFileInput.vue?vue&type=style&index=0&id=2eb1c4ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eb1c4ce"]])

export default __exports__